import React from 'react';
import { useUploadProgress } from '../uploadProgress';

// The one upload progress bar (on the queue card). It subscribes to its own file's progress, so a tick re-renders only this bar.
export default function UploadBar({ id }) {
  const pct = useUploadProgress(id);
  return <div className="sq-bar" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}><i style={{ width: `${Math.min(100, pct)}%` }} /></div>;
}
